import { useContext } from "react";
import { FontSetContext } from "../context/FontSetContext";
import { FontSet } from "@stackje/common/fontSet";
export const useFontSet = () => {
    const { fontSetId } = useContext(FontSetContext);
    return { fontSetId, fontSet: FontSet[fontSetId] };
};
